<template>
  <div
    class="service"
    @click="handleClick"
  >
    <img
      v-scroll-animate="'animate__fadeIn'"
      :class="imgClass"
      :src="imgSrc"
    >
    <div
      :class="textClass"
      class="text"
    >
      <h3 v-scroll-animate="'animate__fadeInUp'">
        {{ title }}
      </h3>
      <p v-scroll-animate="'animate__fadeInUp'">
        {{ subtitle }}
      </p>
      <p v-scroll-animate="'animate__fadeInUp'">
        {{ description }}
      </p>

      <a
        v-scroll-animate="'animate__fadeIn'"
        v-wave="{ color: 'blue' ,
                  initialOpacity: 0.5,
                  duration: 0.3,
                  easing: 'ease-in',}"
        :href="link"
        class="more-button"
      >
        VIEW MORE
        <img src="@/assets/images/toppage-arrow.png">
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: "ServiceItem",
    props: {
        imgClass: { type: String, required: true },
        imgSrc: { type: String, required: true },
        textClass: { type: String, required: true },
        title: { type: String, required: true },
        subtitle: { type: String, required: true },
        description: { type: String, required: true },
        link: { type: String, required: true } 
    },
    methods: {
        handleClick () {
            if (window.innerWidth < 1060) {
                window.location.href = this.link; 
            }
        },
    }
};
</script>



<style lang="scss" scoped>
.service {
  position: relative;
  width: 100%;
  margin: 40px 0 100px;
}

.leftimg {
  max-width: 85%;
  height: auto;
  display: block;
}

.rightimg {
  max-width: 85%;
  height: auto;
  display: inline-block;
  float: right;
}


.text {
  position: absolute;
  top: 10%;
  width: 60%;
  min-width: 400px;
  height: 80%;
  background-color: white;
  z-index: 10;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
  transition: transform 0.5s ease, box-shadow 0.5s ease;
}



.lefttext {
  left: 40%;
}

.righttext {
  right: 40%;
}

.service h3 {
  position: relative;
  font-size: 26px;
  color: #002c4f;
  margin-top: 50px;
  margin-bottom: 0;
  margin-left: 23px;
  padding-left: 23px;
  font-weight: normal;
}

.service h3::before {
  content: "";
  display: block;
  position: absolute;
  width: 2px;
  height: 50%;
  left: -1%;
  top: 15%;
  background-color: #d9001b;
}

.service p1 {
  font-size: 14px;
  line-height: 1.6;
  color: #002c4f;
  padding-left: 50px;
  margin-top: 0;
}

.service p {
  font-size: 18px;
  line-height: 1.6;
  color: #666666;
  margin-top: 0px;
  margin-bottom: 5%;
  padding: 0 50px;
}

.more-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  height: 30px;
  width: 40%;
  bottom: 5%;
  right: 3%;
  padding: 5px 20px;
  font-size: 14px;
  color: #d5d4d5;
  background-color: white;
  border: 1px solid #d5d4d4;
  text-decoration: none;
  cursor: pointer;
  transition: width 0.5s ease-in-out, background-color 0.5s ease, border 0.5s ease, color 0.5s ease;
  z-index: 3;
}

.more-button::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0%;
  background-color: $primaryBlue;
  transition: width 0.5s ease;
  z-index: -3;
}

.text:hover {
  transform: scale(1.03);
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
  .more-button {
    color: white;
    border: 1px solid $primaryBlue;
    background: none;

  }

  .more-button::after {
    display: block;
    width: 100%;
  }
}

@media all and (max-width: 1060px) {
  .content {
    padding: 0 10px;
    max-width: 100%;
  }

  .service {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px 0;
  }

  .service img {
    max-width: 100%;
    height: auto;
  }

  .service .lefttext,
  .service .righttext {
    position: static;
    width: 100%;
    height: auto;
    padding: 5px 3px 40px;
    box-sizing: border-box;
    background-color: #f5f5f5;
  }

  .service h3 {
    font-size: 18px;
    padding: 0 5px;
    border-left: none;
    margin-left: 0;
    margin-top: 0;
  }

  .service h3::before {
    display: none;
  }

  .service p1 {
    font-size: 10px;
    padding: 0 5px;
  }

  .service p {
    font-size: 14px;
    padding: 0 5px;
    margin-top: 0%;
  }

  .more-button {
    font-size: 12px;
    padding: 7px 13px;
    height: auto;
    right: 3%;
    bottom: 2%;
    background: none;
  }

  .text:hover {
  transform: none;
  box-shadow: none;
  .more-button {
    color: #d5d4d5;
    border: 1px solid #d5d4d4;
    background: none;

  }

  .more-button::after {
    display: none;
  }
}
}
</style>
